'use client';
import styled from 'styled-components';

import { PatchedLink } from '@utils/patched-link';

export const FooterLink = styled(PatchedLink)`
  margin-top: 8px 0;
  display: inline-flex;
  align-items: center;
  color: black;
  font-size: 14px;
  line-height: 1;
  font-weight: 300;
  display: inline-block;
  position: relative;
  color: ${({ theme }) => theme.palette.grey1100};
  white-space: nowrap;
  font-size: 12px;
  line-height: 24px;
  font-weight: 500;
  opacity: 0.5;
  text-decoration: none;
  transition: all 0.3s ease-in-out;

  &:hover {
    color: ${({ theme }) => theme.palette.grey1100};
    opacity: 1;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${({ theme }) => theme.mediaQueries.LARGE_1X_UP} {
    width: 282px;
    align-items: flex-end;
  }
`;

export const FooterText = styled.div`
  color: ${({ theme }) => theme.palette.grey1100};
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  opacity: 0.5;
  word-wrap: break-word;
  margin-top: 16px;
`;

export const LinkWrapper = styled.div`
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    align-items: center;
  }
`;
